import React, { useReducer, createContext } from "react"
import { tunnels } from './data'

/*
  type: 'HOBBY', 'MID', 'COMMERCIAL',
  foundation: {
    type: 'SOIL', 'ANCHOR_PLATE', 'FLAT_FEET',
    concrete: false, true
  },
  gableEnd: {
    cover: 'FOLDED', 'CLADDING',
    type: 'PVC', 'SINGLE_TIMBER', 'DOUBLE_TIMBER', 'SINGLE_STEEL', 'DOUBLE_STEEL', 'SINGLE_ALU_EXTERNAL', 'SINGLE_ALU_INTERNAL', 'DOUBLE_ALU_INTERNAL', 'STEEL', 'HALF_MOON'
  }
  secure: 'GROUND', 'CLADDING',
   sideVent: {
    side: 'RIGHT', 'LEFT', 'BOTH',,
    rollUp: false, true
  },
  gutters: 'RIGHT', 'LEFT', 'BOTH',
  longitudinalBars: 2
*/

const initialState = {
  type: 'HOBBY',
  measures: {
    width: 3500,
    length: 10000
  },
  gableEnd: {
    cover: 'FOLDED',
    type: 'PVC'
  },
  gableEnd2: {
    cover: 'FOLDED',
    type: 'SINGLE_TIMBER'
  },
  foundation: {
    type: 'SOIL',
    concrete: false
  },
  secure: 'GROUND',
  sidePurlins: true,
  cropSupportBars: true,
  longitudinalBars: 2,
  antiHotSpotTape: true,
  fadripIrrigation: true,
  overheadIrrigation: true,
  sideVent: {
    side: 'RIGHT',
    rollUp: false
  },
  gutters: 'RIGHT',
  color: 'TRANSPARENT',
  showPlants: true
}

export const StateContext = createContext(window.globalState ? window.globalState : initialState)

export const StateContextProvider = ({ children }) => {
  const reducer = (state, action) => {
    let extraSettings = {}
    const getTypes = (width, cover = state.gableEnd.cover) => Object.keys(tunnels.find(t => t.name.toUpperCase() === state.type).gableEnd.find(g => g.name.toUpperCase() === cover).ends[width])
    const getTypes2 = (width, cover = state.gableEnd2.cover) => Object.keys(tunnels.find(t => t.name.toUpperCase() === state.type).gableEnd.find(g => g.name.toUpperCase() === cover).ends[width])

    switch (action.type) {
      case 'CHANGE_TYPE':
        let defaultParams = {
          measures: {
            width: 2500,
            length: 6000
          },
          gableEnd: {
            cover: 'CLADDING',
            type: 'PVC'
          },
          gableEnd2: {
            cover: 'CLADDING',
            type: 'PVC'
          },
        }

        if(action.payload === 'MID') {
          defaultParams = {
            measures: {
              width: 5500,
              length: 6000
            },
            gableEnd: {
              cover: 'CLADDING',
              type: 'PVC'
            },
            gableEnd2: {
              cover: 'CLADDING',
              type: 'PVC'
            },
          }
        } else if(action.payload === 'COMMERCIAL') {
          defaultParams = {
            measures: {
              width: 7000,
              length: 8000
            },
            gableEnd: {
              cover: 'CLADDING',
              type: 'DOUBLE_TIMBER'
            },
            gableEnd2: {
              cover: 'CLADDING',
              type: 'DOUBLE_TIMBER'
            },
          }
        }

        return {
          ...state,
          type: action.payload,
          ...defaultParams
        }
      case 'CHANGE_WIDTH':
        return {
          ...state,
          measures: {
            ...state.measures,
            width: parseInt(action.payload)
          },
          gableEnd: {
            ...state.gableEnd,
            type: getTypes(action.payload).includes(state.gableEnd.type) ? state.gableEnd.type : getTypes(action.payload)[0],
          },
          gableEnd2: {
            ...state.gableEnd2,
            type: getTypes(action.payload).includes(state.gableEnd2.type) ? state.gableEnd2.type : getTypes(action.payload)[0],
          }
        }
      case 'CHANGE_LENGTH':
        return {
          ...state,
          measures: {
            ...state.measures,
            length: parseInt(action.payload)
          }
        }
      case 'CHANGE_FOUNDATION_TYPE':
        if(action.payload === 'FLAT_FEET') {
          extraSettings.gableEnd = {
            ...state.gableEnd,
            cover: 'CLADDING'
          }
          extraSettings.gableEnd2 = {
            ...state.gableEnd2,
            cover: 'CLADDING'
          }
          extraSettings.secure = 'CLADDING'
        }

        return {
          ...state,
          ...extraSettings,
          foundation: {
            ...state.foundation,
            type: action.payload
          }
        }
      case 'TOGGLE_FOUNDATION_CONCRETE':
        if(!state.foundation.concrete) {
          extraSettings.gableEnd = {
            ...state.gableEnd,
            cover: 'CLADDING'
          }
          extraSettings.gableEnd2 = {
            ...state.gableEnd2,
            cover: 'CLADDING'
          }
          extraSettings.secure = 'CLADDING'
        }

        return {
          ...state,
          ...extraSettings,
          foundation: {
            ...state.foundation,
            concrete: !state.foundation.concrete
          }
        }
      case 'CHANGE_GABLE_END_COVER':
        // extraSettings.secure = action.payload === 'FOLDED' ? 'GROUND' : 'CLADDING'
        return {
          ...state,
          // ...extraSettings,
          gableEnd: {
            type: getTypes(state.measures.width)[0],
            // type: getTypes(state.measures.width).includes(state.gableEnd.type) ? state.gableEnd.type : getTypes(state.measures.width)[0],
            cover: action.payload
          }

        }
      case 'CHANGE_GABLE_END_COVER2':
        // extraSettings.secure = action.payload === 'FOLDED' ? 'GROUND' : 'CLADDING'
        return {
          ...state,
          // ...extraSettings,
          gableEnd2: {
            type: getTypes2(state.measures.width)[0],
            cover: action.payload
          }

        }
      case 'CHANGE_GABLE_END_TYPE':
        return {
          ...state,
          gableEnd: {
            ...state.gableEnd,
            type: action.payload
          }

        }
      case 'CHANGE_GABLE_END_TYPE2':
        return {
          ...state,
          gableEnd2: {
            ...state.gableEnd2,
            type: action.payload
          }

        }
      case 'TOGGLE_SIDE_PURLINS':
        return {
          ...state,
          sidePurlins: !state.sidePurlins
        }
      case 'TOGGLE_CROP_SUPPORT_BARS':
        return {
          ...state,
          cropSupportBars: !state.cropSupportBars
        }
      case 'TOGGLE_LONGITUDINAL_BARS':
        return {
          ...state,
          longitudinalBars: action.payload
        }
      case 'CHANGE_LONGITUDINAL_BARS_AMOUNT':
        let ammountToShow = action.payload
        if(action.payload < 1) ammountToShow = 1
        return {
          ...state,
          longitudinalBars: ammountToShow
        }
      case 'TOGGLE_ANTI_HOT_SPOT_TAPE':
        return {
          ...state,
          antiHotSpotTape: !state.antiHotSpotTape
        }
      case 'TOGGLE_FADRIP_IRRIGATION':
        return {
          ...state,
          fadripIrrigation: !state.fadripIrrigation
        }
      case 'TOGGLE_OVERHEAD_IRRIGATION':
        return {
          ...state,
          overheadIrrigation: !state.overheadIrrigation
        }
      case 'CHANGE_SECURE':
        // if(action.payload === 'GROUND') {
        //   extraSettings.gableEnd = {
        //     cover: 'FOLDED',
        //     type: getTypes(state.measures.width, 'FOLDED').includes(state.gableEnd.type) ? state.gableEnd.type : getTypes(state.measures.width, 'FOLDED')[0]
        //   }
        //   extraSettings.gableEnd2 = {
        //     cover: 'FOLDED',
        //     type: getTypes(state.measures.width, 'FOLDED').includes(state.gableEnd2.type) ? state.gableEnd2.type : getTypes(state.measures.width, 'FOLDED')[0]
        //   }
        // } else if(action.payload === 'CLADDING') {
        //   extraSettings.gableEnd = {
        //     cover: 'CLADDING',
        //     type: getTypes(state.measures.width, 'CLADDING').includes(state.gableEnd.type) ? state.gableEnd.type : getTypes(state.measures.width, 'CLADDING')[0]
        //   }
        //   extraSettings.gableEnd2 = {
        //     cover: 'CLADDING',
        //     type: getTypes(state.measures.width, 'CLADDING').includes(state.gableEnd2.type) ? state.gableEnd2.type : getTypes(state.measures.width, 'CLADDING')[0]
        //   }
        // }

        return {
          ...state,
          secure: action.payload,
          // ...extraSettings
        }
      case 'CHANGE_SIDE_VENT':
        return {
          ...state,
          sideVent: {
            ...state.sideVent,
            side: action.payload === 'false' ? false : action.payload
          }
        }
      case 'TOGGLE_SIDE_VENT_ROLLUP':
        return {
          ...state,
          sideVent: {
            ...state.sideVent,
            rollUp: !state.sideVent.rollUp
          }
        }
      case 'CHANGE_GUTTER':
        return {
          ...state,
          gutters: action.payload
        }
      case 'CHANGE_COLOR':
        return {
          ...state,
          color: action.payload
        }
      case 'TOGGLE_PLANTS':
        return {
          ...state,
          showPlants: !state.showPlants
        }
    }   
  }

  const [state, dispatch] = useReducer(reducer, window.globalState ? window.globalState : initialState)

  return (
    <StateContext.Provider value={{ ...state, dispatch }}>
      {children}
    </StateContext.Provider>
  )
}